import { resourceSettingKey } from '@/modules/hierarchy'

export const assetKeys = {
  root: ['assets'] as const,
  stats: (entityId: string, includeChildren: boolean) =>
    ['assets', 'stats', entityId, includeChildren] as const,
  detail: (entityId: string, assetId: string) =>
    ['assets', 'detail', entityId, assetId] as const,
  printer: (entityId: string, assetId: string) =>
    ['assets', 'printer', entityId, assetId] as const,
  router: (entityId: string, assetId: string) =>
    ['assets', 'router', entityId, assetId] as const,
  supplyPositions: (entityId: string, assetId: string) => ['assets', 'printer', entityId, assetId, 'supply-positions'] as const,
  supplyHistory: (entityId: string, assetId: string, from: string, to: string, positionId: string) =>
    ['assets', 'printer', entityId, assetId, 'supply-history', from, to, positionId] as const,
  routerSources: (entityId: string, assetId: string, after?: string) =>
    ['assets', 'router-sources', entityId, assetId, after] as const,
  // Under the agents root so agent mutations, which invalidate that root, refresh it.
  computer: (entityId: string, assetId: string) =>
    ['agents', 'canonical-computer', entityId, assetId] as const,
  printerFormats: (entityId: string) => ['assets', 'printer-formats', entityId] as const,
  printerCounterKinds: (entityId: string) =>
    ['assets', 'printer-counter-kinds', entityId] as const,
  printerSettings: (entityId: string, assetId: string) =>
    [...resourceSettingKey('printer', assetId), 'effective', entityId] as const,
}
